import React, { useEffect, useState } from "react";
import hero1 from "../assets/TIG Website Images/Career/tigc.png";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/home.css";

import { Container, Row, Col, Card, Nav } from "react-bootstrap";
import { FaUsers, FaLock, FaGraduationCap, FaChartBar, FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Career = () => {
  const navigate = useNavigate();

  // Initialize AOS animations
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  // Benefits data
  const benefits = [
    {
      icon: <FaUsers size={32} />,
      title: "Team Work",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      bg: "rgba(0, 123, 255, 0.1)",
    },
    {
      icon: <FaLock size={32} />,
      title: "Secured Future",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      bg: "rgba(40, 167, 69, 0.1)",
    },
    {
      icon: <FaGraduationCap size={32} />,
      title: "Learning Opportunity",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      bg: "rgba(255, 193, 7, 0.1)",
    },
    {
      icon: <FaChartBar size={32} />,
      title: "Upgrade Skills",
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      bg: "rgba(220, 53, 69, 0.1)",
    },
  ];

  // Categories
  const categories = [
    { id: "ht", name: "HT & ADMIN" },
    { id: "eng", name: "ENGINEERING",  },
    { id: "sup", name: "SUPPORT" },
    { id: "design", name: "DESIGN" },
    { id: "cons", name: "CONSTRUCTIONS" },
  ];

  // Jobs sample
  const jobsData = {
    ht: [
      { id: 1, title: "Admin Executive", experience: "2 Years", deadline: "2025-08-08" },
    ],
    eng: [
      { id: 2, title: "WordPress Developer", experience: "3 Years", deadline: "2025-08-08" },
      { id: 3, title: "Javascript Developer", experience: "4 Years", deadline: "2025-08-08" },
      { id: 4, title: "Apps Developer", experience: "2 Years", deadline: "2025-08-08" },
    ],
    sup: [
      { id: 5, title: "Support Engineer", experience: "1 Year", deadline: "2025-08-08" },
    ],
    design: [
      { id: 6, title: "UI/UX Designer", experience: "3 Years", deadline: "2025-08-08" },
    ],
    cons: [
      { id: 7, title: "Site Supervisor", experience: "5 Years", deadline: "2025-08-08" },
    ],
  };

  const [activeCategory, setActiveCategory] = useState("eng");

  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid p-0">
       <div
  className="hero-section"
  style={{ backgroundImage: `url(${hero1})` }}
>
          <div
            className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100"
            data-aos="fade-up"
          >
            <div className="col-lg-10">
              <h1 className="display-4 fw-bold text-light mb-4">
                Career
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <Container className="py-5">
        <Row className="align-items-center">
          <Col md={6} className="mb-4 mb-md-0" data-aos="fade-up">
            <h6 className="text-uppercase fw-bold text-secondary fs-5">Benefits</h6>
            <h2 className="fw-bold mb-3">
              Why You Should Join Our <br /> Awesome Team
            </h2>
            <p className="text-muted fs-5 pe-md-5">
              We want you to feel at home when working at TIG (Towers International Group). For that, we have curated a great set of benefits for you.
            </p>
          </Col>
          <Col md={6}>
            <Row>
              {benefits.map((item, index) => (
                <Col
                  sm={6}
                  className="mb-4"
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={index * 200}
                >
                  <Card className="border-0 shadow-sm h-100 text-start p-3">
                    <div
                      className="d-inline-flex justify-content-center align-items-center mb-3 rounded"
                      style={{ backgroundColor: item.bg, width: "60px", height: "60px" }}
                    >
                      {item.icon}
                    </div>
                    <h5 className="fw-bold">{item.title}</h5>
                    <p className="text-muted">{item.desc}</p>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>

      {/* Career Openings Section */}
      {/* <Container className="py-2" >
        
        <div className="text-center mb-5" data-aos="fade-up">
          <h6 className="text-uppercase fw-bold text-secondary">Come Join Us</h6>
          <h2 className="fw-bold">Career Openings</h2>
          <p className="text-muted fs-5">
            We’re always looking for creative, talented self-starters to join the TIG family.  <br/>
            Check out our open roles below and fill out an application.
          </p>
        </div>

        <Row>
         
          <Col md={3} className="mb-4" data-aos="fade-up">
            <Nav className="flex-column">
              {categories.map((cat) => (
                <Nav.Link
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`fw-bold mb-2 ${activeCategory === cat.id ? "text-danger" : "text-dark"}`}
                  style={{ cursor: "pointer" }}
                >
                  {cat.name} {cat.count && <span className="text-danger">({cat.count})</span>}
                </Nav.Link>
              ))}
            </Nav>
          </Col>

          
          <Col md={9}>
            <Row>
              {jobsData[activeCategory]?.map((job, index) => (
                <Col
                  md={12}
                  key={job.id}
                  className="mb-3"
                  data-aos="fade-up"
                  data-aos-delay={index * 200}
                >

<Card
  className="d-flex flex-row align-items-center justify-content-between px-4 py-3 shadow-sm border-0 career-card"
  style={{ cursor: "pointer", transition: "0.3s ease-in-out" }}
>
  
  <div className="d-flex flex-column">
    <h5 className="fw-bold mb-1">{job.title}</h5>
    <div className="d-flex text-muted">
      <small className="me-4 fs-text">Experience: {job.experience}</small>
      <small className="fs-text">Deadline: {job.deadline}</small>
    </div>
  </div>

 
  <FaArrowRight
  size={20}
  className="text-secondary"
  style={{ cursor: "pointer" }}
  onClick={() => navigate(`/job/${job.id}`)}
/>

</Card>

                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container> */}
    </div>
  );
};

export default Career;
